import React from 'react';

import { useTranslation } from 'react-i18next';

import { TriggerContainer } from '../../../utils/types';
import InfoTags from '../../info-tags/info-tags';
import useTeamsTag from '../../../hooks/use-teams-tag';

interface Props {
	teamIds: number[];
	triggerFamily: TriggerContainer;
}

const WorkflowInfoTags = ({ teamIds, triggerFamily }: Props) => {
	const { t } = useTranslation();
	const teams = useTeamsTag(teamIds);

	return <InfoTags tags={[teams, t(`AUTOMATION.TRIGGER.${triggerFamily.toUpperCase()}_TITLE`)]} />;
};

export default WorkflowInfoTags;
